module.exports = __webpack_public_path__ + "img/11@2x.c3886542.png";